var _rect, _path, _line, _line2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalyticsfree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2.66667,
    fill: "#EFF5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77764 5.79794C7.0369 7.09424 5.55542 9.79794 5.55542 10.2424H6.11098H12.7776V2.46461L9.99986 7.46461L7.77764 5.79794Z",
    fill: "url(#paint0_linear_1385_17923)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.3333,
    y1: 11.9091,
    x2: 4.44436,
    y2: 11.9091,
    stroke: "url(#paint1_linear_1385_17923)",
    strokeWidth: 1.11111
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.88881,
    y1: 2.46461,
    x2: 3.88881,
    y2: 12.4646,
    stroke: "url(#paint2_linear_1385_17923)",
    strokeWidth: 1.11111
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1385_17923",
    x1: 6.11098,
    y1: 10.2424,
    x2: 12.7776,
    y2: 1.90906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AAFEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1966C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1385_17923",
    x1: 8.88881,
    y1: 11.3535,
    x2: 8.88881,
    y2: 10.3535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38ABEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E72CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1385_17923",
    x1: 3.33325,
    y1: 7.46461,
    x2: 2.33325,
    y2: 7.46461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38ABEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E72CA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsfree);
export default __webpack_public_path__ + "static/media/analyticsfree.c7ed04934310e59c543277a8ad7f62ea.svg";
export { ForwardRef as ReactComponent };